








import { Vue, Component, Prop } from 'vue-property-decorator'
import Vuetify from 'vuetify'

@Component
export default class Countdown extends Vue {
  @Prop({
    required: true
  })
  readonly duration!: number

  // data
  private elapsedTime: number = 0
  private interval!: number

  created () {
    this.startTimer()
  }

  /**
   * Start the timer ticks.
   */
  startTimer () {
    this.interval = setInterval(this.timerTick, 1000)
  }

  /**
   * Increment elapsed time. Once remaining time is zero,
   * the timer is stopped.
   */
  timerTick () {
    this.elapsedTime++

    if (this.interval && (this.duration - this.elapsedTime <= 0)) {
      clearInterval(this.interval)
    }
  }

  /**
   * Calculate remaining time and format into a final
   * countdown display.
   */
  get formattedRemainingTime () {
    const remaining = this.duration - this.elapsedTime
    const minutes = Math.floor(remaining / 60)
    const minutesString = minutes.toString().padStart(2, '0')
    const seconds = Math.floor(remaining % 60)
    const secondsString = seconds.toString().padStart(2, '0')

    return (minutes ? minutesString + ':' : '') + secondsString
  }
}
